import './newCalendar.scss';

import React from 'react';
import { useTranslation } from 'react-i18next';

import ModalTask from '../../common/modal-task/modal-task';
import ModalTaskView from '../modal-task-view/modal-task-view';
import ModalWindow from '../modal/modal';

import { NewCalendarContent, NewCalendarSidebar } from './components';
import { useNewCalendarController } from './useNewCalendar';
import { hasActiveCalendarFilters } from './calendarFilters.helpers';

function NewCalendar() {
  const { t, i18n } = useTranslation();
  const {
    adapterLocale,
    activeMode,
    activePeriod,
    badgeDays,
    badgeLoading,
    categories,
    catChecks,
    closeModalTask,
    closeModalTaskView,
    closeRemoveModal,
    confirmEventCompletion,
    decodedToken,
    executeDeleteTask,
    calendarEvents,
    fullCalendarRef,
    handleCalendarDatesSet,
    handleCalendarEventClick,
    handleCategoryCheckChange,
    handleDateChange,
    handleDateDoubleClick,
    handleEditFromView,
    handleModeChange,
    handleMonthChange,
    handlePeriodChange,
    currentRangeLabel,
    handleNextPeriodClick,
    handlePreviousPeriodClick,
    handleRemoveFromView,
    handleTodayClick,
    localeText,
    modalOpenTask,
    modalOpenTaskView,
    onlyWithHacs,
    openCreateTask,
    openRemoveModal,
    refreshCalendar,
    removeEntityId,
    selectedDate,
    rollbackEventCompletion,
    setOnlyWithHacs,
    setShowSystemTasks,
    startEventCompletion,
    showSystemTasks,
    task,
    taskView,
    taskViewMember,
    advancedFilters,
    setAdvancedFilters,
    pmas,
    members,
  } = useNewCalendarController(i18n.resolvedLanguage || i18n.language);
  const hasActiveFilters = hasActiveCalendarFilters({
    advancedFilters,
    categories,
    categoryChecks: catChecks,
    onlyWithHacs,
    showSystemTasks,
  });

  return (
    <div className="new-calendar-layout">
      <NewCalendarSidebar
        adapterLocale={adapterLocale}
        badgeDays={badgeDays}
        badgeLoading={badgeLoading}
        categories={categories}
        catChecks={catChecks}
        localeText={localeText}
        onCategoryCheckChange={handleCategoryCheckChange}
        onCreateTask={openCreateTask}
        onDateChange={handleDateChange}
        onDateDoubleClick={handleDateDoubleClick}
        onMonthChange={handleMonthChange}
        onlyWithHacs={onlyWithHacs}
        selectedDate={selectedDate}
        setOnlyWithHacs={setOnlyWithHacs}
        setShowSystemTasks={setShowSystemTasks}
        showSystemTasks={showSystemTasks}
      />

      <NewCalendarContent
        activeMode={activeMode}
        activePeriod={activePeriod}
        currentRangeLabel={currentRangeLabel}
        fullCalendarRef={fullCalendarRef}
        onDatesSet={handleCalendarDatesSet}
        onEventClick={handleCalendarEventClick}
        onModeChange={handleModeChange}
        onNextPeriodClick={handleNextPeriodClick}
        onPreviousPeriodClick={handlePreviousPeriodClick}
        onPeriodChange={handlePeriodChange}
        onTodayClick={handleTodayClick}
        calendarEvents={calendarEvents}
        advancedFilters={advancedFilters}
        onAdvancedFiltersChange={setAdvancedFilters}
        pmas={pmas}
        members={members}
        hasActiveFilters={hasActiveFilters}
        isLoading={badgeLoading}
        selectedDate={selectedDate}
      />

      <ModalTask open={modalOpenTask} onClose={closeModalTask} task={task} onSaved={refreshCalendar} />

      <ModalTaskView
        open={modalOpenTaskView}
        onClose={closeModalTaskView}
        task={taskView}
        initialMember={taskViewMember}
        onEdit={handleEditFromView}
        onRemove={handleRemoveFromView}
        onCompletionError={rollbackEventCompletion}
        onCompletionStart={startEventCompletion}
        onCompletionSuccess={confirmEventCompletion}
      />

      <ModalWindow
        open={openRemoveModal}
        handleClose={closeRemoveModal}
        entityId={removeEntityId}
        userId={decodedToken?.id}
        executeFunction={executeDeleteTask}
        postExecuteFunction={refreshCalendar}
        title={t('common-remove')}
        text={t('calendar-remove-reminder-confirmation', { defaultValue: 'Are you sure you want to remove this reminder?' })}
        textButtonCancel={t('common-cancel')}
        textoButtonConfirm={t('common-remove')}
        feedback={t('common-removed', { defaultValue: 'Removed' })}
        errorFeedback={t('calendar-operation-error')}
        extraInfo={null}
      />
    </div>
  );
}

export default NewCalendar;
